import React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

type Avatar9Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar9 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar9Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar9" clipPath="url(#clip0_2286_5303)">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="skin"
          d="M217.728 133.086c0-46.836.151-88.655-39.462-88.655-71.517 0-77.45 29.443-77.45 76.279 0 2.182.104 4.364.287 6.555-1.274.071-2.644.342-4.125.844-6.897 2.341-8.601 14.343-3.815 26.806 4.786 12.464 14.255 20.675 21.152 18.334.327-.112.637-.247.94-.407.988 7.009 3.233 23.693 3.393 30.646.199 8.912-15.307 46.589-15.307 46.589s15.267 31.179 42.615 31.179c27.348 0 36.324-22.108 36.324-22.108s-6.292-12.097-7.51-17.369c-1.219-5.265 7.661-23.94 7.661-23.94 22.992-1.808 29.817-23.828 34.476-56.266 1.983-13.061.829-13.021.829-28.479l-.008-.008Z"
          fill={c.skin}
        />
        <Path
          id="Vector"
          d="M138.518 115.955c-.096.072-.04.223.071.207 2.111-.278 12.767-1.401 20.293-1.258 10.074.199 16.469 7.948 19.137 3.393 1.282-2.19.111-6.411-18.277-8.418-8.092-.884-14.049.971-21.224 6.068v.008Z"
          fill="#000"
        />
        <Path
          id="Vector_2"
          d="M181.786 162.999c-.574 2.716 2.19 4.508 11.659 4.054 7.805-.375 10.313-5.519 8.784-6.236-1.529-.717-3.583 2.508-8.665 2.508-7.406 0-11.213-3.034-11.786-.318l.008-.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_3"
          d="M174.196 137.777c-2.11-4.317-5.129-7.303-8.529-9.366-2.079-1.266-4.301-2.182-6.539-2.843-7.04-2.095-14.295-1.688-17.998-1.617-1.179.024-1.84 1.243-1.171 2.127l1.887 2.492a1.52 1.52 0 0 0 1.307.582c1.704-.112 5.646-.152 10.265.024a5.159 5.159 0 0 0-.518 2.23c0 3.249 3.075 5.885 6.873 5.885 3.361 0 6.149-2.071 6.746-4.794 3.177 1.911 6.013 4.244 7.183 5.582.215.239.63-.008.486-.294l.008-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_4"
          d="M200.374 122.956c.804 1.187 3.074 3.194 4.89 1.848 2.691-2.796 6.657-5.002 12.957-5.177a229.7 229.7 0 0 0-.207-4.093c-14.956.135-18.731 5.797-17.64 7.414v.008Z"
          fill="#000"
        />
        <Path
          id="Vector_5"
          d="M138.884 201.736c-5.105-4.659-10.194-10.481-14.136-16.637 0 .406 2.413 24.537 24.975 41.851 9.533 7.319 17.999 11.603 24.927 13.722.04-6.419 7.518-23.223 7.518-23.223-.374.04-29.259-2.907-43.284-15.713Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_6"
          d="M199.641 135.029a20.913 20.913 0 0 0-1.983 3.497c-.111.254.223.477.398.262.47-.581 1.274-1.385 2.27-2.245 1.091 1.664 3.106 2.803 5.439 2.803 3.481 0 6.308-2.501 6.308-5.591 0-.979-.311-1.887-.813-2.692 3.218.319 4.795 1.609 6.794 1.585.016-1.513.024-3.026.016-4.539-3.17.183-6.833-1.123-10.282.382-3.034 1.322-5.909 3.377-8.147 6.546v-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_7"
          d="M175.733 244.876c2.158 5.854 6.539 14.272 6.539 14.272s-8.968 22.108-36.324 22.108c-27.356 0-42.615-31.179-42.615-31.179s1.099-2.66 2.699-6.738l-2.429.192-51 23.222c26.615 23 61.298 36.914 99.23 36.914 34.317 0 65.974-11.389 91.403-30.59-14.988-8.076-41.604-21.232-67.503-28.193v-.008Z"
          fill="#000"
        />
        <Path
          id="hair"
          d="M235.917 108.597c-4.268-38.72-32.931-60.375-46.653-66.475-13.722-6.1-23.78-1.522-23.78-1.522s-4.97-7.35-34.771-1.107c-96.189 20.15-91.57 194.521-23.318 197.045 10.639-.183 35.829-2.532 35.829-2.532s-14.629-28.774-21.335-60.996c-11.771 2.246-21.789-4.755-26.21-17.131-4.428-12.368-3.392-23.964 2.963-26.241 8.402-3.011 14.041 7.398 17.792 16.015-.144-16.366 4.818-34.308 18.269-34.436 24.497-.239 41.365-41.15 41.365-41.15 22.339 2.931 24.625 5.217 39.844 29.61 1.234 1.975 3.353 33.194 1.601 44.933.987 47.673-25.517 72.385-35.098 73.508-2.429 6.666-7.781 16.047-7.749 22.434 8.737.016 27.54-1.091 48.461-8.465 32.015-11.285 17.075-84.769 12.806-123.49h-.016Z"
          fill={c.hair}
        />
        <Path
          id="Vector_8"
          d="M163.27 179.588c.844.876 14.438 15.227 28.168 15.227 11.691 0 13.977-11.333 14.28-11.97-3.672 1.378-6.698 5.256-13.531 5.256-14.71 0-24.76-5.805-28.917-8.513Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_9"
          d="M197.204 177.549c-3.592 0-4.746 1.545-4.746 1.545s-4.572-1.887-8.394-1.887c-3.823 0-7.295 1.712-10.895 2.142-3.632.43-9.907-.104-9.907-.104s-.032.311 0 .343c4.149 2.254 13.929 3.942 28.638 3.942 6.841 0 10.138-.08 13.81-1.227.008-.023.016-.031.016-.031s-4.938-4.715-8.53-4.715l.008-.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2286_5303">
          <Rect width={303.667} height={303.667} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
